import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnInit,
  Output
} from "@angular/core";
import { MatOptionSelectionChange } from "@angular/material/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { Observable, of } from "rxjs";
import { debounceTime, map, switchMap, tap } from "rxjs/operators";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { GenericComponent } from "../../components/generic.component";
import { VehicleModelService } from "src/app/core/services/vehicle-model.service";
import { VehicleModelDTO } from "../../models/vehicle-model-dto";
import { Pagination } from "@shared/models/pagination";
import { SearchFormDTO } from "src/app/modules/private/modules/vehicle-model/components/models/search-form-dto";

@Component({
    selector: "app-smartfleet-vehicle-model-auto-complete",
    templateUrl: "./vehicle-model-auto-complete.component.html",
    styleUrls: ["./vehicle-model-auto-complete.component.scss"],
    standalone: false
})
export class VehicleModelAutoCompleteComponent
  extends GenericComponent
  implements OnInit, OnChanges
{
  loading = false;
  _disabled = false;
  name = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.name
  });

  models: VehicleModelDTO[] = [];

  @Input() title = "";
  @Input() page = "";
  @Input() requiredText = "";
  @Input() brandId: number;
  @Output() onChange: any = new EventEmitter<VehicleModelDTO>();
  @Input() required: boolean;
  @Input() set disabled(value: boolean) {
    this._disabled = value;
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  constructor(
    private vehicleModelService: VehicleModelService,
    injector: Injector,
    private loadingDrivebService: LoadingDrivebService,
    private cdr: ChangeDetectorRef 
  ) {
    super(injector);
  }

  ngOnInit() {
    if (this.page != "") {
      let key;
      switch (this.page) {
        case "vehicle":
          key = "vc-vehicleModel";
          break;
        case "my-fleet":
          key = "my-fleet-vehicleModel";
          break;
        case "maintenance-plan":
          key = "mp-vehicleModel";
          break;
        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        const vehicle = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.name.setValue(vehicle["displayName"]);
      }
    } else {
      this.clean();
    }
    this.name.valueChanges
      .pipe(
        debounceTime(200),
        tap(
          () => (
            (this.loading = true), this.loadingDrivebService.setAutoMode(false)
          )
        ),
        switchMap((value: string) => {
          if (value) {
            const filters = {} as SearchFormDTO;
            filters.name = value;
            filters.brandId = this.brandId;
            return this.vehicleModelService.findByFilters(filters);
          } else {
            this.loadingDrivebService.setAutoMode(true);
            this.loading = false;
            this.onChange.emit({} as VehicleModelDTO);
            return of({
              content: [],
              pageable: {
                sort: { sorted: false, unsorted: true, empty: true },
                offset: 0,
                pageSize: 0,
                pageNumber: 0,
                unpaged: true,
                paged: false
              },
              totalElements: 0,
              totalPages: 0,
              last: true,
              number: 0,
              size: 0,
              sort: { sorted: false, unsorted: true, empty: true },
              numberOfElements: 0,
              first: true,
              empty: true
            } as Pagination<VehicleModelDTO[]>);
          }
        }),
        map((result: Pagination<VehicleModelDTO[]>) => result?.content ?? [])
      )
      .subscribe((models) => {
        this.models = models;
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
      });
  }

  ngOnChanges(): void {
  const nameControl = this.searchForm.get("name");
  if (!nameControl) return;

  if (this.required && !this._disabled) {
    nameControl.setValidators([Validators.required]);
  } else {
    nameControl.clearValidators();
  }
  nameControl.updateValueAndValidity({ emitEvent: false });
  this.cdr.markForCheck();
}

  handleVehicleModelChange(
    event: MatOptionSelectionChange,
    model: VehicleModelDTO
  ) {
    if (event.isUserInput === true) {
      this.onChange.emit(model);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.models = [];
  }

  setValue(value: string): void {
    this.searchForm.get("name").setValue(value);
    this.models = [];
  }
}
